var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18L22 6C22 3.79086 20.2091 2 18 2L6 2C3.79086 2 2 3.79086 2 6L2 18C2 20.2091 3.79086 22 6 22L18 22C20.2091 22 22 20.2091 22 18Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 16.5202C12.28 16.5302 12.34 16.5402 12.41 16.5402C12.47 16.5402 12.53 16.5402 12.6 16.5202C12.66 16.5102 12.72 16.4902 12.78 16.4702C12.84 16.4502 12.9 16.4102 12.96 16.3702C12.99 16.3502 13.03 16.3402 13.06 16.3202C13.08 16.3002 13.09 16.2702 13.12 16.2502C13.14 16.2302 13.17 16.2202 13.19 16.1902L18 10.4402C18.35 10.0202 18.3 9.39022 17.87 9.03022C17.45 8.68022 16.82 8.73022 16.46 9.16022L12.42 14.0002L8.37999 9.16022C8.02999 8.74022 7.38999 8.68022 6.96999 9.03022C6.72999 9.23022 6.60999 9.51022 6.60999 9.80022C6.60999 10.0302 6.68999 10.2502 6.83999 10.4402L11.65 16.1902C11.65 16.1902 11.7 16.2302 11.73 16.2502C11.75 16.2702 11.76 16.3002 11.78 16.3102C11.81 16.3302 11.85 16.3402 11.88 16.3602C11.94 16.4002 11.99 16.4302 12.06 16.4602C12.12 16.4802 12.18 16.5002 12.24 16.5102L12.22 16.5202Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDownIcon);
export default __webpack_public_path__ + "static/media/expand-down-icon.1409f1e000dba76fc7948c4062cdeafd.svg";
export { ForwardRef as ReactComponent };